import React, { Dispatch, SetStateAction, useState } from "react";
import Modal from "react-modal";
import {
  HorizontalContainer,
  HorizontalLeftAlignedContainer,
  HorizontalSpaceBetweenContainer,
} from "../../styles/container";
import { H2 } from "../../styles/text";
import { FilterToggleButton } from "../../components/buttons/FilterToggleButton";
import { FilterButton } from "../../components/buttons/FilterButton";
import { TextButton } from "../../components/buttons/TextButton";
import { COLORS } from "../../styles/colors";
import { PrimaryButton } from "../../components/buttons/PrimaryButton";
import { getBorderRadius } from "../../utils";
import { SECTION_VERTICAL_SPACING } from "../../styles/spacing";
import { customStyles } from "./constants";

type LightingFilterButtonProps = {
  value: string;
  setValue: Dispatch<SetStateAction<string>>;
  defaultValue: "Any";
};

export const LightingFilterButton = (props: LightingFilterButtonProps) => {
  const { value, setValue, defaultValue } = props;
  const colors = COLORS["light"];

  const [localValue, setLocalValue] = useState<string>(defaultValue);
  const [modalIsOpen, setIsOpen] = React.useState(false);

  // const customStyles = {
  //   content: {
  //     top: "50%",
  //     left: "50%",
  //     right: "auto",
  //     bottom: "auto",
  //     marginRight: "-50%",
  //     transform: "translate(-50%, -50%)",
  //     borderRadius: getBorderRadius("medium", "rounded rect"),
  //   },
  //   overlay: {
  //     zIndex: 1000,
  //   },
  // };

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  const handleClick = () => {
    openModal();
  };

  const handleSelect = () => {
    setValue(localValue);
    closeModal();
    // clear location?
  };

  const handleCancel = () => {
    closeModal();
  };

  const handleReset = () => {
    setLocalValue(defaultValue);
  };

  return (
    <>
      <FilterButton
        title={value === "Any" ? "Lighting" : value}
        onClick={handleClick}
        active={value !== "Any"}
        iconName="sunny-outline"
      />
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Example Modal"
        style={customStyles}
        appElement={document.getElementById("root") as HTMLElement}
      >
        <div
          style={{
            flex: 1,
          }}
        >
          <HorizontalSpaceBetweenContainer style={{ marginBottom: 24 }}>
            <H2>Dusk Lighting</H2>
            <TextButton
              title="Reset"
              onClick={() => handleReset()}
              color={colors.PRIMARY_BRAND}
            />
          </HorizontalSpaceBetweenContainer>

          <HorizontalLeftAlignedContainer
            style={{ width: 300, paddingBottom: SECTION_VERTICAL_SPACING }}
          >
            <FilterToggleButton
              title="Any"
              onClick={() => setLocalValue("Any")}
              selected={localValue === "Any"}
            />
            <FilterToggleButton
              title="Dusk Lighting"
              onClick={() => setLocalValue("Dusk Lighting")}
              selected={localValue === "Dusk Lighting"}
            />
          </HorizontalLeftAlignedContainer>
          <HorizontalContainer>
            <PrimaryButton
              flex={1}
              onClick={handleSelect}
              type="button"
              title="Apply"
            />
          </HorizontalContainer>
        </div>
      </Modal>
    </>
  );
};
